import React from "react";
import BondGeneralInformationBase from "../../../../features/bonds/shared/components/BondGeneralInformationBase";
import { GENERAL_INFORMATION_CONFIG } from "../../../../features/bonds/shared/generalInformationConfig";
import { RETRIEVE_GLOBAL_DATA_ROLE_DISABLED } from "./bondRetrieveSharedPropTypes";

const GuardianshipGeneralInformation = (props) => (
  <BondGeneralInformationBase
    cfg={GENERAL_INFORMATION_CONFIG.guardianship.retrieval}
    {...props}
  />
);

GuardianshipGeneralInformation.propTypes = RETRIEVE_GLOBAL_DATA_ROLE_DISABLED;

export default GuardianshipGeneralInformation;
